import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase"; // Adjust path if needed

const navLinks = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/courses-to-promote", label: "Courses To Promote" },
  { to: "/referral", label: "Referral" },
  { to: "/commissions", label: "Commissions" },
  { to: "/profile", label: "Profile" },
];

export default function MobileSidebar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    setOpen(false);
    navigate("/login");
  };

  return (
    <div className="md:hidden">
      {/* Hamburger button */}
      <button
        className="fixed top-4 left-4 z-50 bg-white/80 p-2 rounded-full shadow"
        onClick={() => setOpen(true)}
      >
        <Menu className="w-6 h-6 text-blue-600" />
      </button>

      {/* Sidebar Drawer */}
      <div
        className={`fixed top-0 left-0 w-64 h-full bg-white shadow-xl z-50 flex flex-col transition-transform duration-200 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-4 py-4 border-b">
          <span className="font-bold text-lg text-blue-700">
            Referral Dashboard
          </span>
          <button onClick={() => setOpen(false)}>
            <X className="w-6 h-6" />
          </button>
        </div>
        <nav className="flex-1 flex flex-col p-4 gap-2">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className="py-2 px-4 rounded hover:bg-blue-50 text-blue-700 font-semibold"
              onClick={() => setOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        {/* Logout at bottom */}
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-2 px-4 py-3 text-red-600 font-semibold border-t border-gray-100 hover:bg-red-50 transition"
        >
          <LogOut className="w-5 h-5" />
          Logout
        </button>
      </div>

      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/30 z-40"
          onClick={() => setOpen(false)}
        />
      )}
    </div>
  );
}
